/* AWS buckt static website, cloudfront domain */
let CDN_URL = "https://d3netxia5l27z5.cloudfront.net";

let SERVER_URL = "/";

if (process.env.REACT_APP_ENV === "DEV") {
  SERVER_URL = "http://localhost:3001";
}
export { CDN_URL, SERVER_URL };
